(function () {
    'use strict';

    angular
        .module('businessUnitModule')
        .directive('businessUnit', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope        = _.clone(boxTmplScope);
        directiveScope.highlight = '=';
        directiveScope.onSelect = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/businessUnit/businessUnit.[Template].tpl.html';

                    $controller('BoxTmplController', {$scope: $scope});
                }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                if (attrs.onSelect) scope.showOnSelectAction = true;
            }
        }
    }
})();